import React from 'react';
import parse from 'html-react-parser';
import { Row, Col, Container, Alert } from '@bootstrap-styled/v4';
import {
    HistoryContainer,
    DonationListMain,
    DonationListItem,
    DonationDescriptionContainer,
    MemberIdLink,
    ForgotPasswordContainer,
    SendLinkContainer,
    ForgotBody,
    FormItem,
    MemoContant,
    BackArrow,
    IconBox,
    CardDetail,
    CancelLink,
} from './styles';
import { Text } from '../../../common/Text/Text';
import { MainSection, RightSide } from '../../../common/Layout/styles';
import TextInput from '../../../common/Input/TextInput';
import Icon from '../../../common/Icon';
import {
    amountNumberFormat,
    decodeTextContent,
} from '../../../../../../utils/functions';
import { H2 } from '../../../common/H2/styles';
import Divider from '../../../common/Divider';
import GiftProcessingBanner from '../../../CheckoutWizard/ThankYouWizard/GiftProcessingBanner';
import GiftFailedBanner, { GiftHistoryDetail } from './GiftFailedBanner';
import { Button } from '../../../../../ui';
import { Dialog, IconButton, Link } from '@mui/material';

interface HistoryDetailDesignProps {
    success?: string;
    error?: string;
    closeMessage: () => () => void;
    exitDetail: () => void;
    memberId?: string;
    memberIdPopup: boolean;
    memberIdInput?: string;
    updateMemberIdAction: () => boolean;
    memberIdDelete: () => void;
    memberIdModalOpen: () => void;
    memberIdModalClose: () => void;
    apiError?: string;
    onMemberIdInput: (value: string) => boolean;
    loading: boolean;
    details: GiftHistoryDetail;
    memo?: string;
    creditNo: string;
}

const HistoryDetailDesign: React.FC<HistoryDetailDesignProps> = ({
    success,
    error,
    closeMessage,
    exitDetail,
    memberId,
    memberIdPopup,
    memberIdInput,
    updateMemberIdAction,
    memberIdDelete,
    memberIdModalOpen,
    memberIdModalClose,
    apiError,
    onMemberIdInput,
    loading,
    details,
    memo,
    creditNo,
}) => {
    return (
        <div className={'mainpart'}>
            <Container>
                {(success !== undefined || error !== undefined) && (
                    <center>
                        {success !== undefined && (
                            <Alert
                                className={'common-alert m-0'}
                                color={'success'}
                                isOpen
                                onClick={closeMessage()}
                            >
                                <Text
                                    variant={'xSmall'}
                                    color={'grey3'}
                                >
                                    {success}
                                </Text>
                            </Alert>
                        )}
                        {error !== undefined && (
                            <Alert
                                className={'common-alert'}
                                color={'danger'}
                                isOpen
                                onClick={closeMessage()}
                            >
                                <Text
                                    variant={'xSmall'}
                                    color={'grey3'}
                                >
                                    {error}
                                </Text>
                            </Alert>
                        )}
                    </center>
                )}
                <MainSection className={'position-r'}>
                    <BackArrow onClick={() => exitDetail()}>
                        <IconBox>
                            <Icon
                                size={'medium'}
                                name={'back_arrow'}
                            />
                        </IconBox>
                        <Text color={'primaryGuidingViolet'}> Back </Text>
                    </BackArrow>
                    {details &&
                        details.donee &&
                        details.gift &&
                        details.envelopes && (
                            <Row className={'justify-content-center'}>
                                <Col
                                    lg={6}
                                    md={8}
                                    sm={10}
                                >
                                    <HistoryContainer>
                                        <center>
                                            <H2
                                                size={'large'}
                                                color={'grayscaleBlack'}
                                                weight={'medium'}
                                            >
                                                Past Gift
                                            </H2>
                                            <br />
                                            <H2
                                                size={'large'}
                                                color={'grayscaleBlack'}
                                                weight={'medium'}
                                            >
                                                {details.donee.name}
                                            </H2>
                                            <Text
                                                variant={'medium'}
                                                color={
                                                    'primarySecondaryContent'
                                                }
                                            >
                                                {' '}
                                                {details.gift.date}{' '}
                                            </Text>
                                        </center>
                                        <br />
                                        {details.gift.status === 'pending' && (
                                            <GiftProcessingBanner />
                                        )}
                                        {details.gift.status === 'declined' && (
                                            <GiftFailedBanner
                                                detail={details}
                                            />
                                        )}
                                        <DonationListMain>
                                            {details.detailType === 'history'
                                                ? details.envelopes.map(
                                                      (item: any) => (
                                                          <DonationListItem
                                                              className={
                                                                  'donationlist'
                                                              }
                                                              key={item.id}
                                                          >
                                                              <Row>
                                                                  <Col xs={8}>
                                                                      <DonationDescriptionContainer
                                                                          className={
                                                                              'donationlistname'
                                                                          }
                                                                      >
                                                                          <Text
                                                                              color={
                                                                                  'primarySecondaryContent'
                                                                              }
                                                                          >
                                                                              {' '}
                                                                              {
                                                                                  item.name
                                                                              }{' '}
                                                                          </Text>
                                                                      </DonationDescriptionContainer>
                                                                  </Col>
                                                                  <Col xs={4}>
                                                                      <RightSide>
                                                                          <Text
                                                                              color={
                                                                                  'grey3'
                                                                              }
                                                                          >
                                                                              {' '}
                                                                              {amountNumberFormat(
                                                                                  item.amount,
                                                                              )}{' '}
                                                                          </Text>
                                                                      </RightSide>
                                                                  </Col>
                                                              </Row>
                                                          </DonationListItem>
                                                      ),
                                                  )
                                                : details.envelopes.map(
                                                      (item: any) => (
                                                          <DonationListItem
                                                              className={
                                                                  'donationlist'
                                                              }
                                                              key={item.id}
                                                          >
                                                              <Row>
                                                                  <Col xs={8}>
                                                                      <DonationDescriptionContainer
                                                                          className={
                                                                              'donationlistname'
                                                                          }
                                                                      >
                                                                          <Text
                                                                              color={
                                                                                  'primarySecondaryContent'
                                                                              }
                                                                          >
                                                                              {' '}
                                                                              {
                                                                                  item.name
                                                                              }{' '}
                                                                          </Text>
                                                                      </DonationDescriptionContainer>
                                                                  </Col>
                                                                  <Col xs={4}>
                                                                      <RightSide>
                                                                          <Text
                                                                              color={
                                                                                  'grey3'
                                                                              }
                                                                          >
                                                                              {' '}
                                                                              {amountNumberFormat(
                                                                                  item.amount,
                                                                              )}{' '}
                                                                          </Text>
                                                                      </RightSide>
                                                                  </Col>
                                                              </Row>
                                                          </DonationListItem>
                                                      ),
                                                  )}
                                            <Divider className={'mb-5px'} />
                                            <Row>
                                                <Col xs={12}>
                                                    <RightSide>
                                                        <Text
                                                            color={'grey3'}
                                                            variant={'medium'}
                                                            weight={'medium'}
                                                        >
                                                            {' '}
                                                            Total:{' '}
                                                            {amountNumberFormat(
                                                                details.gift
                                                                    .amount,
                                                            )}
                                                        </Text>
                                                    </RightSide>
                                                </Col>
                                            </Row>
                                            <br />
                                        </DonationListMain>

                                        {memo && (
                                            <MemoContant>
                                                <Text
                                                    color={
                                                        'primarySecondaryContent'
                                                    }
                                                >
                                                    Message
                                                </Text>
                                                <br />
                                                <Text
                                                    color={'grey3'}
                                                    variant={'small'}
                                                >
                                                    {parse(memo)}{' '}
                                                </Text>
                                            </MemoContant>
                                        )}
                                        <br />
                                        <DonationListMain>
                                            <Row>
                                                <Col xs={8}>
                                                    <DonationDescriptionContainer
                                                        className={
                                                            'donationlistname'
                                                        }
                                                    >
                                                        <MemberIdLink>
                                                            <Text
                                                                color={
                                                                    'primaryGuidingViolet'
                                                                }
                                                                weight={
                                                                    'medium'
                                                                }
                                                                onClick={
                                                                    memberIdModalOpen
                                                                }
                                                            >
                                                                {' '}
                                                                {memberId ===
                                                                undefined
                                                                    ? 'Add'
                                                                    : 'Edit'}{' '}
                                                                Member
                                                                ID/Envelope#
                                                            </Text>
                                                        </MemberIdLink>
                                                    </DonationDescriptionContainer>
                                                </Col>
                                                <Col xs={4}>
                                                    <RightSide>
                                                        <Text
                                                            color={
                                                                'primaryGuidingViolet'
                                                            }
                                                            weight={'medium'}
                                                        >
                                                            {decodeTextContent(
                                                                memberId,
                                                            )}
                                                        </Text>
                                                    </RightSide>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12}>
                                                    <DonationDescriptionContainer>
                                                        <Text
                                                            variant={'small'}
                                                            color={
                                                                'primarySecondaryContent'
                                                            }
                                                        >
                                                            Assigned to you by
                                                            the organization
                                                        </Text>
                                                    </DonationDescriptionContainer>
                                                </Col>
                                            </Row>
                                        </DonationListMain>
                                        <br />
                                        <DonationListMain>
                                            <Row className={'mt-5px'}>
                                                <Col xs={5}>
                                                    <DonationDescriptionContainer
                                                        className={
                                                            'donationlistname'
                                                        }
                                                    >
                                                        <Text
                                                            color={
                                                                'primarySecondaryContent'
                                                            }
                                                        >
                                                            {' '}
                                                            Credit card{' '}
                                                        </Text>
                                                    </DonationDescriptionContainer>
                                                </Col>
                                                <Col xs={7}>
                                                    <RightSide>
                                                        <CardDetail>
                                                            {typeof details.gift
                                                                .accountType !==
                                                                'undefined' && (
                                                                <Icon
                                                                    size={
                                                                        'large'
                                                                    }
                                                                    name={
                                                                        `${details.gift.accountType.toLowerCase()}-logo` as any
                                                                    }
                                                                    className={
                                                                        'recurring-card'
                                                                    }
                                                                />
                                                            )}
                                                            <Text
                                                                className={
                                                                    'card_no'
                                                                }
                                                                color={'grey3'}
                                                            >
                                                                {' '}
                                                                {creditNo}{' '}
                                                            </Text>
                                                        </CardDetail>
                                                    </RightSide>
                                                </Col>
                                            </Row>
                                            <Row className={'mt-5px'}>
                                                <Col xs={5}>
                                                    <DonationDescriptionContainer
                                                        className={
                                                            'donationlistname'
                                                        }
                                                    >
                                                        <Text
                                                            color={
                                                                'primarySecondaryContent'
                                                            }
                                                        >
                                                            {' '}
                                                            Receipt #{' '}
                                                        </Text>
                                                    </DonationDescriptionContainer>
                                                </Col>
                                                <Col xs={7}>
                                                    <RightSide>
                                                        <Text color={'grey3'}>
                                                            {' '}
                                                            {
                                                                details.gift
                                                                    .receiptNumber
                                                            }{' '}
                                                        </Text>
                                                    </RightSide>
                                                </Col>
                                            </Row>
                                        </DonationListMain>
                                    </HistoryContainer>
                                </Col>
                            </Row>
                        )}
                </MainSection>
            </Container>
            <Dialog
                data-testid="change-password-dialog"
                open={memberIdPopup}
                onClose={memberIdModalClose}
                container={document.getElementById('root')}
                maxWidth="xs"
                fullWidth
                sx={{
                    '& .MuiBackdrop-root': { backgroundColor: '#f1f0f7cc' },
                    '& .MuiDialog-paper': {
                        borderRadius: '24px',
                        padding: '48px 24px',
                        backgroundColor: '#ffffff',
                        boxShadow:
                            '0 1px 6px 0 rgba(10, 0, 77, 0.04), 0 5.5px 30px 0 rgba(10, 0, 77, 0.05)',
                        minWidth: 320,
                        position: 'relative',
                    },
                }}
            >
                <IconButton
                    data-testid="change-password-dialog-close"
                    className="absolute right-3 top-3"
                    onClick={memberIdModalClose}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM14.8467 8.03906C15.1378 7.74238 15.6152 7.74022 15.9092 8.03418C16.1989 8.32414 16.201 8.79318 15.9141 9.08594L13.0576 12L15.9141 14.9141C16.201 15.2068 16.1989 15.6759 15.9092 15.9658C15.6152 16.2598 15.1378 16.2576 14.8467 15.9609L12 13.0576L9.15332 15.9609C8.86217 16.2576 8.38478 16.2598 8.09082 15.9658C7.80106 15.6759 7.79897 15.2068 8.08594 14.9141L10.9424 12L8.03906 9.15332C7.74236 8.86217 7.74021 8.38479 8.03418 8.09082C8.32415 7.80104 8.79317 7.79895 9.08594 8.08594L12 10.9424L14.8467 8.03906Z"
                            fill="#6A6873"
                        />
                    </svg>
                </IconButton>
                <ForgotPasswordContainer>
                    <center>
                        <Text
                            className={'popup-title mb-10px'}
                            color={'grayscaleBlack'}
                        >
                            {memberId === undefined ? 'Add' : 'Edit'} Member
                            ID/Envelope#
                        </Text>
                    </center>
                    <ForgotBody>
                        <FormItem>
                            <TextInput
                                placeholder={'Member Id/Envelope#'}
                                value={
                                    decodeTextContent(memberIdInput) as string
                                }
                                type={'text'}
                                onChange={(e) =>
                                    onMemberIdInput(e.target.value)
                                }
                                maxLength={16}
                            />
                            {apiError !== undefined && (
                                <Text color={'red'}>{apiError}</Text>
                            )}
                        </FormItem>
                    </ForgotBody>
                    <SendLinkContainer>
                        <Button
                            variant="primary"
                            onClick={updateMemberIdAction}
                        >
                            {loading ? 'Saving...' : 'Save'}
                        </Button>
                        {memberId !== undefined && (
                            <div>
                                <br />
                                <Link
                                    component="button"
                                    type="button"
                                    underline="hover"
                                    sx={CancelLink}
                                    onClick={() => {
                                        memberIdDelete();
                                    }}
                                >
                                    Delete Member ID/Envelope#
                                </Link>
                            </div>
                        )}
                    </SendLinkContainer>
                </ForgotPasswordContainer>
            </Dialog>
        </div>
    );
};

export default HistoryDetailDesign;
